export const es= {
    action:{
        accept:"Acepta",
        postponi:"Pospón",
        declina:"Rechaza",
        cancel:"Cancela",
        download:"Descarga",
        app:"Abre la App",
        salta:"Salta",
        close:"Cierra"
    },
    onboard:{
        lang:{
            title:"Selecciona",
            text:"¿En qué idioma prefieres escuchar los contenidos?"
        },
        tag:{
            title:"Acerca el smartphone a los SilenceTags",
            text:"Utiliza la APP para acceder a los contenidos"
        },
        qr:{
            alternative:"Si no",
            title:"Escanea",
            text:"Encuadra los códigos QR que encontrarás durante el recorrido"
        },


    },
    networkerror:{
		title:"Error Network",
        text:"No es posible descargar los contenidos en modalidad offline!",
        action:"Intenta más tarde"
    },
    storageError:{
		title:"Espacio insuficiente",
        text:"No es posible descargar los contenidos. Utiliza la modalidad online para hacerlo!",
        action:"Ok"
    },
    update:{
		title:"Actualizaciones",
        text:"Hay nuevas actualizaciones disponibles! ¿Deseas descargarlas ahora?"
    },
    scarica:{
		title:"Desacarga los contenidos",							 
        text:"La APP estará disponible pronto. Puede requerir algunos minutos"
    },
    main:{

        scan:"Escanéa el código",
        start:"Escanéa el SilenceTag",
        stop:"Para el SilenceTag",
        alertApp:{
            title:"Función no disponible",
            text:"Esta función està disponible solo en la APP",
        },
		timeoutTagTitle:"ALERTA",
		timeoutTagText:"SilenceTag NO detectado, quizá esté apagado. Utiliza el,\"Escanea el código QR\" botón",
		timeoutTagAccept:"Continúa"
    
    },

    menu:{
        title:"Configuración",
        content:{
            title:"Actualiza los contenidos"
        },
        lang:{
            title:"Idioma",
            subtitile:"Descarga idiomas",
            add:"Agrega un nuevo idioma",
            select:"Contenido disponible",
            alert:"Alerta, con esta operacion descargarás los contenidos en el idioma seleccionado",
            it:"Italiano",
            en:"Inglés",
            fr:"Francés",
            de:"Alemán",
            es:"Español"
        },
        help:"Ayuda",
        copyright:"Copyright",
        privacy:"Política de Privacidad",
        termini:"Términos de servicio",
        test:{
            title:"Test",
            inizioTest:"Iniciar TEST",
            stopTest:"Dejar TEST",
            testoIstruzioni:"Desconecte sus auriculares, suba el volumen y ejecute la prueba",
            compatibileTest:"El dispositivo es compatible",
            nonCompatibileTest:"El dispositivo no es compatible",
        }
        
    },
    raccolta:{
        title:"Recolección de datos",
        subtitle:"Revive nuevamente la experiencia",
        alerttext:"Aún no hay contenidos visualizados. \n Al final del recorrido encontrarás los contenidos en esta sección"
    }
   
}